import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import ChipInput from "material-ui-chip-input";
import RichTextEditor from "react-rte";

const StepTwo = (props) => {
    const [editorState, setEditorState] = useState(props.publishDetail.publish_detail["description"] ?
        RichTextEditor.createValueFromString(props.publishDetail.publish_detail["description"].toString("html"), "html") :
        RichTextEditor.createEmptyValue())
    const {t} = useTranslation();
    const [chips, setChips] = useState({tags: props.publishDetail.publish_detail["tags"] ? props.publishDetail.publish_detail["tags"].split(",") : []})

    const handleAddChip = (chip) => {
        setChips({
            tags: [...chips.tags, chip]
        })
    }
    const handleDeleteChip = (chip) => {
        setChips({
            tags: chips.tags.filter((c) => c !== chip)
        })
    }

    useEffect(() => {
        props.setPublishDetail(oldState => ({
            publish_detail: {
                ...oldState.publish_detail,
                tags: chips.tags.join()
            }
        }))

    }, [chips]);

    const handleEdit = value => {
        setEditorState(value)
        props.setPublishDetail(oldState => ({
            publish_detail: {
                ...oldState.publish_detail,
                description: editorState
            }
        }))
    }

    useEffect(() => {
        let valHtml = editorState.toString('html').replace(/(<([^>]+)>)/gi, "").trim()
        if (valHtml.length > 0 && chips.tags.length > 0) {
            props.setIsRequired(false)
        } else {
            props.setIsRequired(true)
        }
    }, [chips, editorState]);

    return (
        <DialogContent style={{padding: "20px 0 0 0"}}>
            <div style={{textAlign: "left"}}>
                <Grid container>
                    <Grid item xs={3}>
                        <span className="dialog-text">
                            {props.publishDetail.publish_detail.type === "library" ? "Library " : "Bot "}
                            {t('CONTENT.PUBLISH.AUTOM-TAG')}</span>
                    </Grid>
                    <Grid item xs={12}>
                        <ChipInput
                            style={{
                                backgroundColor: "#FCFCFC",
                                borderRadius: "5px",
                                border: "1px solid #E6E6E6",
                                padding: "5px",
                                fontSize: "12px"
                            }}
                            inputprops={{style: {fontSize: 12}}}
                            fullWidth
                            newChipKeyCodes={[188]}
                            value={chips.tags}
                            onAdd={(chip) => handleAddChip(chip)}
                            onDelete={(chip, index) => handleDeleteChip(chip)}
                        />
                    </Grid>
                    <Grid item style={{marginBottom: "1rem"}} xs={12}>
                        <span className="dialog-text-small">{t('CONTENT.PUBLISH.AUTOM-TAG-DESC')}</span>
                    </Grid>

                    <Grid item xs={3}>
                        <span className="dialog-text">{t('CONTENT.PUBLISH.LONG-DESC')}</span>
                    </Grid>
                    <Grid item xs={12}>
                        <RichTextEditor
                            editorClassName="publish-editor"
                            value={editorState}
                            onChange={value => handleEdit(value)}
                        />
                    </Grid>
                </Grid>
            </div>
        </DialogContent>

    );
};

export default StepTwo;
